"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.transitions = exports.NotificationsContext = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var React = _interopRequireWildcard(require("react"));

var _types = require("./types");

var _transitions;

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NotificationsContext = React.createContext({
  dismissAll: _noop.default,
  isDismissingAll: false,
  notifications: [],
  notify: _noop.default
});
exports.NotificationsContext = NotificationsContext;
var transitions = (_transitions = {}, _defineProperty(_transitions, _types.NotificationState.ENTERING, {
  next: _types.NotificationState.DISPLAYING,
  duration: 10
}), _defineProperty(_transitions, _types.NotificationState.DISPLAYING, {
  next: _types.NotificationState.COLLAPSING,
  duration: null
}), _defineProperty(_transitions, _types.NotificationState.COLLAPSING, {
  next: null,
  duration: 200
}), _defineProperty(_transitions, _types.NotificationState.COLLAPSING_ALL, {
  next: null,
  duration: 2500
}), _transitions);
exports.transitions = transitions;

function NotificationsProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      notifications = _React$useState2[0],
      setNotifications = _React$useState2[1];
  /**
   * Advances a notification to either the specified state or the next state for the current state
   */


  function transition(notificationID, state) {
    setNotifications(function (oldNotifications) {
      return (0, _compact.default)(oldNotifications.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 3),
            props = _ref3[0],
            body = _ref3[1],
            meta = _ref3[2];

        if (meta.notificationID === notificationID) {
          var next = transitions[meta.state].next;
          var nextState = state || next; // next will be null in the final state. When this is the case, the
          // notification should be removed without additional transitions.

          if (nextState) {
            var duration = transitions[nextState].duration; // duration will be null when "DISPLAYING". This prevents auto-dismiss.

            if (typeof duration === 'number') {
              setTimeout(function () {
                transition(notificationID);
              }, duration);
            }

            return [props, body, _objectSpread({}, meta, {
              state: nextState
            })];
          }

          if (meta.state === _types.NotificationState.COLLAPSING_ALL && props.onClose) {
            try {
              props.onClose(new MouseEvent('click'));
            } catch (_unused) {
              // IE doesn't support MouseEvent. If you support IE, you must verify or mock
              // attributes required by this event handler.
              props.onClose({});
            }
          }

          return undefined;
        }

        return [props, body, meta];
      }));
    });
  }

  var dismissAll = function dismissAll() {
    setNotifications(function (oldNotifications) {
      oldNotifications.forEach(function (_ref4, index) {
        var _ref5 = _slicedToArray(_ref4, 3),
            meta = _ref5[2];

        setTimeout(function () {
          return transition(meta.notificationID, _types.NotificationState.COLLAPSING_ALL);
        }, index * 100);
      });
      return oldNotifications;
    });
  };

  var notify = React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    setNotifications(function (oldNotifications) {
      var options;
      var body;

      if (typeof args[0] === 'function') {
        // A notify handler callback may return void, indicating there should be no new
        // notification dispatched.
        var newNotificationParams = args[0](oldNotifications);

        if (!newNotificationParams) {
          // In the scenario where a callback arg is provided but returns void,
          // block the rest of the logic and move on. There should be no change.
          return oldNotifications;
        }

        var _newNotificationParam = _slicedToArray(newNotificationParams, 2);

        options = _newNotificationParam[0];
        body = _newNotificationParam[1];
      } else {
        var _ref6 = args;

        var _ref7 = _slicedToArray(_ref6, 2);

        options = _ref7[0];
        body = _ref7[1];
      }

      var notificationID = (0, _uniqueId.default)("notification-".concat(options.id, "-"));
      var duration = transitions[_types.NotificationState.ENTERING].duration;
      setTimeout(function () {
        transition(notificationID);
      }, duration);
      var autoDismiss = options.duration && setTimeout(function () {
        transition(notificationID, _types.NotificationState.COLLAPSING);
      }, duration + options.duration);

      var closeNotificationAfter = function closeNotificationAfter(callback) {
        return function (event) {
          if (callback) {
            callback(event);
          }

          transition(notificationID, _types.NotificationState.COLLAPSING);
        };
      };

      var suspendAutoDismiss = function suspendAutoDismiss() {
        clearTimeout(autoDismiss);
      };

      var actions = options.actions && options.actions.map(function (_ref8) {
        var onClick = _ref8.onClick,
            rest = _objectWithoutProperties(_ref8, ["onClick"]);

        return _objectSpread({
          onClick: closeNotificationAfter(onClick)
        }, rest);
      });
      return [[_objectSpread({}, options, {
        actions: actions,
        id: options.id || notificationID,
        onClose: options.onClose && closeNotificationAfter(options.onClose),
        onFocus: suspendAutoDismiss,
        onHover: suspendAutoDismiss
      }), body, {
        notificationID: notificationID,
        state: _types.NotificationState.ENTERING
      }]].concat(_toConsumableArray(oldNotifications));
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [setNotifications]);
  var isDismissingAll = React.useMemo(function () {
    return !(0, _isEmpty.default)(notifications) && notifications[0][2].state === _types.NotificationState.COLLAPSING_ALL;
  }, [notifications]);
  return React.createElement(NotificationsContext.Provider, {
    value: {
      dismissAll: dismissAll,
      isDismissingAll: isDismissingAll,
      notifications: notifications,
      notify: notify
    }
  }, children);
}

var _default = NotificationsProvider;
exports.default = _default;